import React from 'react';
import { Button, Row, Col, Spinner, Container, ButtonGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEuroSign } from '@fortawesome/free-solid-svg-icons';
import Block from '../common/Display/Block';
import { t } from '../common/Translate';
import MenuNavBottom from '../common/MenuNavBottom';
import '../../assets/scss/react-datepicker.css';
import RecordsResults from './RecordsResults';
import { useSupervisorList } from '../../hooks/useForm/useSupervisorList';
import QuantityBadge from './QuantityBadge';
import AutobizStrapPopup from '../common/Modal/AutobizStrapPopup';

const SupervisorList = (props) => {
  const {
    records,
    goToPage,
    pageCount,
    tabs,
    refresh,
    currentPage,
    loading,
    error,
    filters,
    currentTab,
    setSort,
    sort,
  } = useSupervisorList(props);

  return (
    <Block {...props} noBack>
      <AutobizStrapPopup />
      <h1 className="page-title">
        <span className="cursor-pointer">
          <FontAwesomeIcon icon={faEuroSign} className="mr-2" />
          {t('supervision')}
        </span>
        <button type="button" onClick={refresh} className="btn refresh-button btn-3">
          {loading && <Spinner size="sm" className="spinner-loader" />} {t('refresh')}
        </button>
      </h1>
      <div className="filters-results-container">
        <Container fluid>
          <Row>
            <Col xs="12" className="switch-dashboard">
              <ButtonGroup className="d-block">
                {tabs.map(({ selected, onClick, count, name, type }) => (
                  <Button onClick={onClick} key={type} color="primary" outline={!selected}>
                    {name}
                    <QuantityBadge count={count} />
                  </Button>
                ))}
              </ButtonGroup>
            </Col>
          </Row>
          <Row>
            <RecordsResults
              currentPage={currentPage}
              pageNumbers={pageCount}
              loading={loading}
              changePaginationIndex={goToPage}
              forms={records}
              error={error}
              origin="supervision"
              currentTab={currentTab}
              tableFilters={filters}
              setSort={setSort}
              sort={sort}
            />
          </Row>
        </Container>
      </div>
      <MenuNavBottom active="supervision" />
    </Block>
  );
};

export default SupervisorList;
